var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-content",style:(_vm.styleString),attrs:{"title":_vm.filterName}},[_c('p',[_vm._v(_vm._s(_vm.filterName))]),_c('button',{attrs:{"disabled":_vm.isFetching},on:{"click":function($event){$event.preventDefault();return _vm.buttonClicked.apply(null, arguments)}}},[_c('Xicon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }